import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { api, ApiHttpError } from '~/lib/api/client'
import type { SnapshotPayload } from '~/lib/api/types'

export const SNAPSHOT_QUERY_KEY = ['snapshot', 'today'] as const

export function useSnapshotToday() {
  return useQuery<SnapshotPayload, ApiHttpError>({
    queryKey: SNAPSHOT_QUERY_KEY,
    queryFn: api.getSnapshotToday,
    refetchOnWindowFocus: true,
    staleTime: 30 * 1000,
  })
}

export function useInvalidateSnapshot() {
  const qc = useQueryClient()
  return useCallback(() => {
    qc.invalidateQueries({ queryKey: SNAPSHOT_QUERY_KEY })
  }, [qc])
}
